module.exports = __webpack_public_path__ + "img/close-white.7defd0c8.svg";